function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('./../../lib/templates/modtemplate');
var SaitoHeader = require('./../../lib/saito/ui/saito-header/saito-header');
var RustscriptMain = require('./lib/ui/main');
var ast_execute = require('./lib/rustscript/ast_execute');
var tokenize = require('./lib/rustscript/semantic_to_tokens');
var parse = require('./lib/rustscript/tokens_to_ast');
var _require = require('./lib/ui/script_build'),
  build_test_script_from_create = _require.build_test_script_from_create,
  lockingView = _require.lockingView,
  expandLockingTree = _require.expandLockingTree;
var _require2 = require('./lib/transaction_io'),
  downloadTransactionFile = _require2.downloadTransactionFile,
  serializeTransactionToWeb = _require2.serializeTransactionToWeb,
  transactionExportFilename = _require2.transactionExportFilename;
var _require3 = require('./lib/tx_location'),
  fetchTransactionFromP2shLink = _require3.fetchTransactionFromP2shLink,
  parseP2shShareLink = _require3.parseP2shShareLink,
  readTransactionLocation = _require3.readTransactionLocation;
var Transaction = require('./../../lib/saito/transaction')["default"];
var Slip = require('./../../lib/saito/slip')["default"];
var _require4 = require('saito-js/lib/transaction'),
  TransactionType = _require4.TransactionType;
var _require5 = require('saito-js/lib/slip'),
  SlipType = _require5.SlipType;

/** Saito SlipType::P2SH — not yet exported from saito-js SlipType enum. */
var SLIP_TYPE_P2SH = 10;
function slipToStoredJson(slip) {
  if (!slip) {
    return null;
  }
  var json;
  if (typeof slip.toJson === 'function') {
    json = slip.toJson();
  } else {
    json = {
      publicKey: slip.publicKey,
      amount: slip.amount,
      type: slip.type,
      blockId: slip.blockId,
      txOrdinal: slip.txOrdinal,
      index: slip.index
    };
  }
  return json;
}
function isBoundSlipType(type) {
  return type === SlipType.Bound || type === 9;
}
function isNormalOrAtrSlipType(type) {
  return type === SlipType.Normal || type === SlipType.ATR || type === 0 || type === 1;
}
var OpcodeChecksig = require('./lib/opcodes/checksig');
var OpcodeCheckmultisig = require('./lib/opcodes/checkmultisig');
var OpcodeCheckhash = require('./lib/opcodes/checkhash');
var OpcodeCheckfield = require('./lib/opcodes/checkfield');
var OpcodeCheckkey = require('./lib/opcodes/checkkey');
var OpcodeChecksender = require('./lib/opcodes/checksender');
var OpcodeCheckrecipient = require('./lib/opcodes/checkrecipient');
var OpcodeCheckpath = require('./lib/opcodes/checkpath');
var OpcodeCheckpathhop = require('./lib/opcodes/checkpathhop');
var OpcodeImportfield = require('./lib/opcodes/importfield');
var OpcodeImportarray = require('./lib/opcodes/importarray');
var OpcodeSetfield = require('./lib/opcodes/setfield');
var OpcodeSetarray = require('./lib/opcodes/setarray');
var OpcodeSetarrayfield = require('./lib/opcodes/setarrayfield');
var OpcodeArrayify = require('./lib/opcodes/arrayify');
var OpcodeSumfields = require('./lib/opcodes/sumfields');
var OpcodeScripthash = require('./lib/opcodes/scripthash');
var OpcodeCheckown = require('./lib/opcodes/checkown');
var OpcodeCheckownnft = require('./lib/opcodes/checkownnft');
var OpcodeCheckownnftwhere = require('./lib/opcodes/checkownnftwhere');
var OpcodeChecktime = require('./lib/opcodes/checktime');
var Rustscript = /*#__PURE__*/function (_ModTemplate) {
  function Rustscript(app) {
    var _this;
    _classCallCheck(this, Rustscript);
    _this = _callSuper(this, Rustscript, [app]);
    _this.appname = 'Rustscript';
    _this.name = 'Rustscript';
    _this.slug = 'rustscript';
    _this.description = 'Symbolic P2SH contract scripting';
    _this.categories = 'Utility Programming Cryptography';
    _this.status = 'beta';
    _this["class"] = 'utility';
    _this.styles = ['/rustscript/style.css', '/saito/css-imports/ui/saito-nft.css'];
    _this.icon = 'fas fa-code';
    _this.script = {};
    _this.opcodes = {};
    _this.main = null;
    _this.header = null;

    /** @type {'create'|'unlock'} */
    _this.workflow = 'create';
    _this.unlockContext = null;

    /**
     * Unlock transaction ownership model.
     * - spend: immutable locked-funds snapshot (locking tx, or continuation UTXO view)
     * - base: UI-owned editable unlock tx (imported inputs + user outputs only)
     * - candidate: disposable evaluation clone (tracks base, then funded final after signing prep)
     * - final: silently funded clone (fee inputs + change); created before first CHECKSIG
     */
    _this.unlock_transaction_spend = null;
    _this.unlock_transaction_base = null;
    _this.unlock_transaction_candidate = null;
    /**
     * Funded unlock tx (base + wallet fee inputs/change). Built silently before
     * the first CHECKSIG/CHECKMULTISIG; used for signing and broadcast.
     */
    _this.unlock_transaction_final = null;
    /** @type {{ feeSaito: string, feeNolan: string } | null} */
    _this.unlock_fee = null;
    /**
     * Explicit RustScript unlock editability. Becomes false after the first
     * successful CHECKSIG / CHECKMULTISIG witness is applied.
     */
    _this.unlock_transaction_editable = true;
    return _this;
  }
  _inherits(Rustscript, _ModTemplate);
  return _createClass(Rustscript, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _superPropGet2,
          _this2 = this;
        var SaitoTransactionMonitor;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (_superPropGet2 = _superPropGet(Rustscript, "initialize", this, 3)) === null || _superPropGet2 === void 0 ? void 0 : _superPropGet2([app]);
            case 1:
              if (this.app.BROWSER) {
                SaitoTransactionMonitor = require('../../lib/saito/ui/saito-transaction-monitor/saito-transaction-monitor');
                this.transaction_monitor = new SaitoTransactionMonitor(this.app, this);
              }
              [OpcodeChecksig, OpcodeCheckmultisig, OpcodeCheckhash, OpcodeCheckfield, OpcodeCheckkey, OpcodeChecksender, OpcodeCheckrecipient, OpcodeCheckpath, OpcodeCheckpathhop, OpcodeImportfield, OpcodeImportarray, OpcodeSetfield, OpcodeSetarray, OpcodeSetarrayfield, OpcodeArrayify, OpcodeSumfields, OpcodeScripthash, OpcodeCheckown, OpcodeCheckownnft, OpcodeCheckownnftwhere, OpcodeChecktime].forEach(function (op) {
                if (op && op.name && typeof op.execute === 'function') {
                  var key = op.name.toLowerCase();
                  _this2.opcodes[key] = function (node, context) {
                    return op.execute(node, context) === true;
                  };
                  _this2.opcodes[key].opcode = op;
                }
              });
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(!this.app.BROWSER || !this.browser_active)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (this.header) {
                _context2.n = 3;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context2.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.addComponent(this.header);
            case 3:
              if (!this.main) {
                this.main = new RustscriptMain(this.app, this);
                this.addComponent(this.main);
              }
              _context2.n = 4;
              return this.header.render();
            case 4:
              _context2.n = 5;
              return this.main.render();
            case 5:
              _context2.n = 6;
              return this.consumeExplorerImport();
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "consumeExplorerImport",
    value: function () {
      var _consumeExplorerImport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var raw, _payload$target, _this$main, payload, tx, _t, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (this.app.BROWSER) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              raw = null;
              _context3.p = 2;
              raw = sessionStorage.getItem('rustscript_explorer_import');
              if (raw) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              sessionStorage.removeItem('rustscript_explorer_import');
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t = _context3.v;
              return _context3.a(2);
            case 5:
              _context3.p = 5;
              payload = JSON.parse(raw);
              if (payload !== null && payload !== void 0 && payload.tx) {
                _context3.n = 6;
                break;
              }
              return _context3.a(2);
            case 6:
              tx = new Transaction();
              tx.deserialize_from_web(this.app, JSON.stringify(payload.tx));
              if (!(((_payload$target = payload.target) === null || _payload$target === void 0 ? void 0 : _payload$target.kind) === 'input' && payload.target.fromIndex != null)) {
                _context3.n = 8;
                break;
              }
              _context3.n = 7;
              return this.loadP2shInputForWitness(tx, payload.target.fromIndex);
            case 7:
              _context3.n = 9;
              break;
            case 8:
              _context3.n = 9;
              return this.loadTransactionForWitness(tx);
            case 9:
              if ((_this$main = this.main) !== null && _this$main !== void 0 && _this$main.welcomeOverlay) {
                this.main.welcomeOverlay.dismiss('explorer');
              }
              _context3.n = 11;
              break;
            case 10:
              _context3.p = 10;
              _t2 = _context3.v;
              console.warn('Rustscript: explorer import failed', _t2);
            case 11:
              return _context3.a(2);
          }
        }, _callee3, this, [[5, 10], [2, 4]]);
      }));
      function consumeExplorerImport() {
        return _consumeExplorerImport.apply(this, arguments);
      }
      return consumeExplorerImport;
    }()
  }, {
    key: "_isP2shMarkerSlip",
    value: function _isP2shMarkerSlip(slip) {
      var _slip$type;
      if (!slip) {
        return false;
      }
      var type = Number((_slip$type = slip.type) !== null && _slip$type !== void 0 ? _slip$type : slip.slip_type);
      if (type === SLIP_TYPE_P2SH) {
        return true;
      }
      var pk = String(slip.publicKey || slip.public_key || '');
      return pk.length >= 66 && pk.startsWith('00');
    }
  }, {
    key: "_findFundSlipBeforeP2shMarker",
    value: function _findFundSlipBeforeP2shMarker(tx, markerIndex) {
      var from = tx.from || [];
      for (var i = markerIndex - 1; i >= 0; i--) {
        var _slip$type2;
        var slip = from[i];
        var type = Number((_slip$type2 = slip === null || slip === void 0 ? void 0 : slip.type) !== null && _slip$type2 !== void 0 ? _slip$type2 : slip === null || slip === void 0 ? void 0 : slip.slip_type);
        if (type === SlipType.Bound || type === 9) {
          continue;
        }
        return slip;
      }
      return null;
    }

    /**
     * Load a spend transaction's P2SH input witness for inspection / unlock testing.
     */
  }, {
    key: "loadP2shInputForWitness",
    value: function () {
      var _loadP2shInputForWitness = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(tx, fromIndex) {
        var from, marker, p2shArrayIndex, i, fundSlip, txmsg, accessScripts, accessScriptRaw, fullScript, locking, hash, p2shPublicKey, p2shAddress;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (tx) {
                _context4.n = 1;
                break;
              }
              throw new Error('Transaction is required');
            case 1:
              from = tx.from || [];
              marker = from[fromIndex];
              if (!(!marker || !this._isP2shMarkerSlip(marker))) {
                _context4.n = 2;
                break;
              }
              throw new Error('Selected slip is not a P2SH input marker');
            case 2:
              p2shArrayIndex = 0;
              for (i = 0; i < fromIndex; i++) {
                if (this._isP2shMarkerSlip(from[i])) {
                  p2shArrayIndex += 1;
                }
              }
              fundSlip = this._findFundSlipBeforeP2shMarker(tx, fromIndex);
              if (fundSlip) {
                _context4.n = 3;
                break;
              }
              throw new Error('Could not locate fund slip for P2SH input');
            case 3:
              txmsg = typeof tx.returnMessage === 'function' ? tx.returnMessage() : tx.msg || {};
              accessScripts = Array.isArray(txmsg.access_scripts) ? txmsg.access_scripts : [];
              accessScriptRaw = accessScripts[p2shArrayIndex];
              if (accessScriptRaw) {
                _context4.n = 4;
                break;
              }
              throw new Error('access_scripts entry not found for P2SH input');
            case 4:
              fullScript = typeof accessScriptRaw === 'string' ? JSON.parse(accessScriptRaw) : accessScriptRaw;
              locking = lockingView(fullScript);
              hash = this.app.core.scripting.hash(locking);
              p2shPublicKey = marker.publicKey || marker.public_key || '';
              p2shAddress = p2shPublicKey.length === 66 && p2shPublicKey.startsWith('00') ? this.app.crypto.toBase58(p2shPublicKey) : p2shPublicKey;
              this.unlockContext = {
                sourceTxSignature: tx.signature || '',
                p2shAddress: p2shAddress,
                p2shHash: txmsg.scripthash || hash || '',
                lockedSlip: slipToStoredJson(fundSlip),
                assetType: 'saito',
                lockedNftSlips: null,
                importCategory: 'guided',
                sourceTxmsg: txmsg,
                p2shInputFromIndex: fromIndex
              };
              this.workflow = 'unlock';
              this.initializeUnlockTransactions(tx);
              if (!this.main) {
                _context4.n = 5;
                break;
              }
              this.main.testingUnlocked = true;
              this.main.executionStatus = {
                attempted: false,
                success: false
              };
              this.main.validationDisplay = null;
              this.main.workspaceMode = 'locked';
              this.setScript(fullScript);
              this.main.syncEditorModes();
              this.main.applyWorkspaceUI();
              _context4.n = 5;
              return this.main.refresh();
            case 5:
              return _context4.a(2, this.unlockContext);
          }
        }, _callee4, this);
      }));
      function loadP2shInputForWitness(_x2, _x3) {
        return _loadP2shInputForWitness.apply(this, arguments);
      }
      return loadP2shInputForWitness;
    }()
  }, {
    key: "respondTo",
    value: function respondTo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (type === 'saito-header') {
        if (!this.browser_active) {
          return [{
            text: 'Rustscript',
            icon: this.icon,
            rank: 110,
            type: 'navigation',
            callback: function callback() {
              navigateWindow('/rustscript');
            }
          }];
        }
      }
      return null;
    }
  }, {
    key: "setScript",
    value: function setScript(script) {
      if (!script || _typeof(script) !== 'object' || Array.isArray(script)) {
        return;
      }
      this.script = JSON.parse(JSON.stringify(script));
    }
  }, {
    key: "getScript",
    value: function getScript() {
      return JSON.parse(JSON.stringify(this.script));
    }
  }, {
    key: "setField",
    value: function setField(path, value) {
      if (typeof path !== 'string' || path.length === 0) {
        return;
      }
      if (this.workflow === 'unlock') {
        var _require6 = require('./lib/ui/unlock_tx_fee'),
          assertUnlockMutablePath = _require6.assertUnlockMutablePath;
        assertUnlockMutablePath(this, path);
      }
      var parts = path.split('.');
      var cursor = this.script;
      for (var i = 0; i < parts.length - 1; i += 1) {
        var key = parts[i];
        var nextKey = parts[i + 1];
        var nextIsIndex = /^\d+$/.test(nextKey);
        if (Array.isArray(cursor)) {
          var idx = parseInt(key, 10);
          cursor = cursor[idx];
          continue;
        }
        if (!cursor[key] || _typeof(cursor[key]) !== 'object') {
          cursor[key] = nextIsIndex ? [] : {};
        }
        cursor = cursor[key];
      }
      var last = parts[parts.length - 1];
      if (Array.isArray(cursor)) {
        cursor[parseInt(last, 10)] = value;
      } else {
        cursor[last] = value;
      }
    }
  }, {
    key: "getField",
    value: function getField(path) {
      if (typeof path !== 'string' || path.length === 0) {
        return undefined;
      }
      var parts = path.split('.');
      var cursor = this.script;
      var _iterator = _createForOfIteratorHelper(parts),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var part = _step.value;
          if (cursor == null) {
            return undefined;
          }
          if (Array.isArray(cursor)) {
            var idx = parseInt(part, 10);
            if (!Number.isInteger(idx) || idx < 0 || idx >= cursor.length) {
              return undefined;
            }
            cursor = cursor[idx];
          } else if (_typeof(cursor) === 'object') {
            cursor = cursor[part];
          } else {
            return undefined;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return cursor;
    }
  }, {
    key: "execute",
    value: function execute(context) {
      if (!context || _typeof(context) !== 'object') {
        return false;
      }
      var clone = JSON.parse(JSON.stringify(this.script));
      var pending = [clone];
      while (pending.length > 0) {
        var node = pending.pop();
        if (!node || _typeof(node) !== 'object') {
          continue;
        }
        if (Array.isArray(node)) {
          for (var i = 0; i < node.length; i += 1) {
            pending.push(node[i]);
          }
          continue;
        }
        if (node.required && _typeof(node.required) === 'object' && !Array.isArray(node.required)) {
          if (!node.witness || _typeof(node.witness) !== 'object' || Array.isArray(node.witness)) {
            node.witness = {};
          }
          var keys = Object.keys(node.required);
          for (var k = 0; k < keys.length; k += 1) {
            var key = keys[k];
            if (node.witness[key] === undefined) {
              node.witness[key] = node.required[key];
            }
          }
        }
        if (Array.isArray(node.args)) {
          for (var _i = 0; _i < node.args.length; _i += 1) {
            pending.push(node.args[_i]);
          }
        }
      }
      if (!clone || _typeof(clone) !== 'object' || typeof clone.op !== 'string' || clone.op.length === 0) {
        return false;
      }
      var execContext = context.opcodes ? context : Object.assign({}, context, {
        opcodes: this.opcodes
      });
      var result = ast_execute(clone, execContext);
      return result === true;
    }
  }, {
    key: "scripthash",
    value: function scripthash() {
      return this.app.core.scripting.hash(lockingView(this.script));
    }
  }, {
    key: "parseExpertScript",
    value: function parseExpertScript(source) {
      var text = String(source !== null && source !== void 0 ? source : '').trim();
      if (!text) {
        throw new Error('Script is empty');
      }
      var tokens = tokenize(text);
      var ast = parse(tokens);
      var lockingScript = expandLockingTree(lockingView(ast || {}), this.opcodes);
      var unlockingScript = build_test_script_from_create(lockingScript, {}, this.opcodes);
      return {
        tokens: tokens,
        ast: ast,
        lockingScript: lockingScript,
        unlockingScript: unlockingScript,
        json: JSON.stringify(lockingScript, null, 2)
      };
    }
  }, {
    key: "shouldAffixCallbackToModule",
    value: function shouldAffixCallbackToModule(modname) {
      var _this$transaction_mon;
      var tx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (modname === this.name) {
        return 1;
      }
      // Allow the shared transaction monitor to receive confirmations it is watching.
      if ((_this$transaction_mon = this.transaction_monitor) !== null && _this$transaction_mon !== void 0 && _this$transaction_mon.tx && tx !== null && tx !== void 0 && tx.signature && tx.signature === this.transaction_monitor.tx.signature) {
        return 1;
      }
      return 0;
    }
  }, {
    key: "resetUnlockWorkflow",
    value: function resetUnlockWorkflow() {
      this.workflow = 'create';
      this.unlockContext = null;
      this.clearUnlockTransactions();
    }

    /**
     * Deep-clone a Transaction via canonical web serialization.
     * Used for the immutable spend snapshot (complete imported tx).
     */
  }, {
    key: "cloneTransaction",
    value: function cloneTransaction(tx) {
      if (!tx) {
        throw new Error('Transaction is required');
      }
      var json = this.serializeTransaction(tx);
      var clone = new Transaction();
      clone.deserialize_from_web(this.app, json);
      return clone;
    }

    /**
     * Clone from/to slips + msg without requiring a fully signed / complete tx.
     * Used for base ↔ candidate where outputs may be absent.
     */
  }, {
    key: "cloneTransactionSkeleton",
    value: function cloneTransactionSkeleton(tx) {
      if (!tx) {
        throw new Error('Transaction is required');
      }
      var clone = new Transaction();
      clone.timestamp = tx.timestamp || Date.now();
      if (tx.type != null) {
        clone.type = tx.type;
      }
      var from = tx.from || [];
      for (var i = 0; i < from.length; i++) {
        var stored = slipToStoredJson(from[i]);
        clone.addFromSlip(new Slip(undefined, stored));
      }
      var to = tx.to || [];
      for (var _i2 = 0; _i2 < to.length; _i2++) {
        var _stored = slipToStoredJson(to[_i2]);
        clone.addToSlip(new Slip(undefined, _stored));
      }
      var msg = tx.msg && _typeof(tx.msg) === 'object' && Object.keys(tx.msg).length ? tx.msg : typeof tx.returnMessage === 'function' ? tx.returnMessage() : null;
      if (msg && _typeof(msg) === 'object') {
        clone.msg = JSON.parse(JSON.stringify(msg));
      }
      return clone;
    }
  }, {
    key: "clearUnlockTransactions",
    value: function clearUnlockTransactions() {
      this.unlock_transaction_spend = null;
      this.unlock_transaction_base = null;
      this.unlock_transaction_candidate = null;
      this.unlock_transaction_final = null;
      this.unlock_fee = null;
      this.unlock_transaction_editable = true;
    }

    /**
     * Build the UI-owned unlock base transaction: spendable inputs only.
     * No outputs, fee inputs, or signatures.
     */
  }, {
    key: "createUnlockBaseTransaction",
    value: function createUnlockBaseTransaction() {
      var ctx = this.unlockContext;
      if (!(ctx !== null && ctx !== void 0 && ctx.lockedSlip) && !(Array.isArray(ctx === null || ctx === void 0 ? void 0 : ctx.lockedNftSlips) && ctx.lockedNftSlips.length)) {
        throw new Error('Unlock context is required to create the base transaction');
      }
      var base = new Transaction();
      base.timestamp = Date.now();
      if (ctx.assetType === 'nft' && Array.isArray(ctx.lockedNftSlips) && ctx.lockedNftSlips.length === 3) {
        for (var i = 0; i < ctx.lockedNftSlips.length; i++) {
          base.addFromSlip(new Slip(undefined, ctx.lockedNftSlips[i]));
        }
      } else {
        base.addFromSlip(new Slip(undefined, ctx.lockedSlip));
      }
      return base;
    }

    /**
     * Disposable evaluation clone.
     * Prefer unlock_transaction_final once fee funding has been composed;
     * otherwise clone unlock_transaction_base.
     * Never edit this object; always regenerate via this helper.
     */
  }, {
    key: "cloneUnlockCandidate",
    value: function cloneUnlockCandidate() {
      if (this.unlock_transaction_final) {
        this.unlock_transaction_candidate = this.cloneTransactionSkeleton(this.unlock_transaction_final);
        return this.unlock_transaction_candidate;
      }
      if (!this.unlock_transaction_base) {
        this.unlock_transaction_candidate = null;
        return null;
      }
      this.unlock_transaction_candidate = this.cloneTransactionSkeleton(this.unlock_transaction_base);
      return this.unlock_transaction_candidate;
    }

    /**
     * Establish unlock transaction ownership after unlockContext is populated.
     * @param {object} spendTx - imported transaction (cloned into unlock_transaction_spend)
     */
  }, {
    key: "initializeUnlockTransactions",
    value: function initializeUnlockTransactions(spendTx) {
      if (!spendTx) {
        throw new Error('Imported transaction is required');
      }
      if (!this.unlockContext) {
        throw new Error('unlockContext must be set before initializeUnlockTransactions');
      }
      this.unlock_transaction_spend = this.cloneTransaction(spendTx);
      this.unlock_transaction_base = this.createUnlockBaseTransaction();
      this.unlock_transaction_final = null;
      this.unlock_fee = null;
      this.unlock_transaction_editable = true;
      var _require7 = require('./lib/ui/unlock_tx_fee'),
        ensureDefaultUnlockFee = _require7.ensureDefaultUnlockFee;
      ensureDefaultUnlockFee(this);
      this.cloneUnlockCandidate();
    }

    /**
     * Immutable spend snapshot for Continue Unlock: funds being spent recorded as outputs.
     * The original locking/publish file is not required when continuing from an unlock draft.
     */
  }, {
    key: "createUnlockSpendSnapshotFromContinuation",
    value: function createUnlockSpendSnapshotFromContinuation(unlockTx) {
      var spend = new Transaction();
      spend.timestamp = (unlockTx === null || unlockTx === void 0 ? void 0 : unlockTx.timestamp) || Date.now();
      var from = (unlockTx === null || unlockTx === void 0 ? void 0 : unlockTx.from) || [];
      if (!from.length) {
        throw new Error('Unlock transaction has no inputs to spend.');
      }
      for (var i = 0; i < from.length; i++) {
        spend.addToSlip(new Slip(undefined, slipToStoredJson(from[i])));
      }
      return spend;
    }

    /**
     * Continue Unlock init — base is the imported unlock tx (outputs + witnesses preserved).
     */
  }, {
    key: "initializeUnlockTransactionsFromContinuation",
    value: function initializeUnlockTransactionsFromContinuation(unlockTx) {
      if (!unlockTx) {
        throw new Error('Unlock transaction is required');
      }
      if (!this.unlockContext) {
        throw new Error('unlockContext must be set before initializeUnlockTransactionsFromContinuation');
      }
      this.unlock_transaction_spend = this.createUnlockSpendSnapshotFromContinuation(unlockTx);
      this.unlock_transaction_base = this.cloneTransactionSkeleton(unlockTx);
      this.unlock_transaction_final = null;
      this.unlock_fee = null;
      this.unlock_transaction_editable = true;
      var _require8 = require('./lib/ui/unlock_tx_fee'),
        ensureDefaultUnlockFee = _require8.ensureDefaultUnlockFee;
      ensureDefaultUnlockFee(this);
      this.cloneUnlockCandidate();
    }

    /**
     * Load an in-progress unlock/spend transaction and open the Unlock workspace.
     * Preserves outputs and witnesses — does not scaffold an empty base tx.
     */
  }, {
    key: "loadUnlockContinuation",
    value: function () {
      var _loadUnlockContinuation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(tx) {
        var _from$;
        var from, to, txmsg, request, hasAccessScripts, accessScriptRaw, fullScript, locking, hash, p2shHash, p2shAddress, assetType, lockedNftSlips, lockedSlip, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (tx) {
                _context5.n = 1;
                break;
              }
              throw new Error('Transaction is required');
            case 1:
              from = tx.from || [];
              to = tx.to || [];
              if (from.length) {
                _context5.n = 2;
                break;
              }
              throw new Error('This file has no inputs. Import a locking transaction via Unlock Transaction instead.');
            case 2:
              if (to.length) {
                _context5.n = 3;
                break;
              }
              throw new Error('This unlock transaction has no outputs yet. Use Unlock Transaction to start a new unlock.');
            case 3:
              txmsg = typeof tx.returnMessage === 'function' ? tx.returnMessage() : tx.msg || {};
              request = String(txmsg.request || '').toLowerCase();
              if (!(request === 'publish p2sh')) {
                _context5.n = 4;
                break;
              }
              throw new Error('This looks like a locking/publish transaction. Use Unlock Transaction to start unlocking it.');
            case 4:
              hasAccessScripts = Array.isArray(txmsg.access_scripts) && txmsg.access_scripts.length > 0;
              accessScriptRaw = hasAccessScripts ? txmsg.access_scripts[0] : request === 'spend p2sh' ? txmsg.access_script || txmsg.accessScript || '' : '';
              if (accessScriptRaw) {
                _context5.n = 5;
                break;
              }
              throw new Error('This file is not an unlock transaction with an access script. Use Unlock Transaction for locking publishes, or Import Saved Script for script drafts.');
            case 5:
              _context5.p = 5;
              fullScript = typeof accessScriptRaw === 'string' ? JSON.parse(accessScriptRaw) : accessScriptRaw;
              _context5.n = 7;
              break;
            case 6:
              _context5.p = 6;
              _t3 = _context5.v;
              throw new Error('access_script is not valid JSON');
            case 7:
              if (!(!fullScript || _typeof(fullScript) !== 'object' || Array.isArray(fullScript))) {
                _context5.n = 8;
                break;
              }
              throw new Error('access_script is not a valid script object.');
            case 8:
              locking = lockingView(fullScript);
              hash = this.app.core.scripting.hash(locking);
              p2shHash = txmsg.scripthash || hash || '';
              p2shAddress = txmsg.p2sh_address || txmsg.p2shAddress || '';
              assetType = txmsg.asset_type === 'nft' || txmsg.nft_id || isBoundSlipType((_from$ = from[0]) === null || _from$ === void 0 ? void 0 : _from$.type) ? 'nft' : txmsg.asset_type || 'saito';
              lockedNftSlips = null;
              lockedSlip = null;
              if (assetType === 'nft' && from.length >= 3) {
                lockedNftSlips = [from[0], from[1], from[2]].map(slipToStoredJson);
                lockedSlip = lockedNftSlips[1];
              } else {
                lockedSlip = slipToStoredJson(from[0]);
              }
              this.unlockContext = {
                sourceTxSignature: txmsg.source_tx || tx.signature || '',
                p2shAddress: p2shAddress,
                p2shHash: p2shHash,
                lockedSlip: lockedSlip,
                assetType: assetType,
                lockedNftSlips: lockedNftSlips,
                nftId: txmsg.nft_id || '',
                nftAmount: txmsg.nft_amount || '',
                nftTxmsg: txmsg.nft_txmsg && _typeof(txmsg.nft_txmsg) === 'object' ? txmsg.nft_txmsg : null,
                importCategory: 'guided',
                sourceTxmsg: txmsg,
                continuation: true
              };
              this.workflow = 'unlock';
              this.initializeUnlockTransactionsFromContinuation(tx);
              if (!this.main) {
                _context5.n = 9;
                break;
              }
              _context5.n = 9;
              return this.main.enterUnlockContinuation(fullScript);
            case 9:
              return _context5.a(2, this.unlockContext);
          }
        }, _callee5, this, [[5, 6]]);
      }));
      function loadUnlockContinuation(_x4) {
        return _loadUnlockContinuation.apply(this, arguments);
      }
      return loadUnlockContinuation;
    }() /** Canonical web-serialized transaction JSON (shared with import / future explorer export). */
  }, {
    key: "serializeTransaction",
    value: function serializeTransaction(tx) {
      return serializeTransactionToWeb(this.app, tx);
    }

    /**
     * Download a transaction as canonical JSON via the browser.
     * Pass block_id / transaction_id with update_outputs so outputs carry
     * confirmed chain location in the serialized file.
     */
  }, {
    key: "exportTransaction",
    value: function exportTransaction(tx) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        prefix = _ref.prefix,
        _ref$block_id = _ref.block_id,
        block_id = _ref$block_id === void 0 ? null : _ref$block_id,
        _ref$transaction_id = _ref.transaction_id,
        transaction_id = _ref$transaction_id === void 0 ? null : _ref$transaction_id;
      if (!tx) {
        throw new Error('Transaction is required');
      }
      var filename = prefix ? transactionExportFilename(tx, prefix) : undefined;
      if (block_id != null && String(block_id) !== '' && transaction_id != null && String(transaction_id) !== '') {
        return downloadTransactionFile(this.app, tx, {
          filename: filename,
          block_id: block_id,
          transaction_id: transaction_id,
          update_outputs: true
        });
      }
      return downloadTransactionFile(this.app, tx, {
        filename: filename
      });
    }

    /**
     * Build a shareable draft transaction wrapping the script at its current state.
     * Uses the same web-serialization path as publish export (no broadcast).
     */
  }, {
    key: "buildScriptShareTransaction",
    value: function buildScriptShareTransaction(scriptPayload) {
      if (!scriptPayload || _typeof(scriptPayload) !== 'object') {
        throw new Error('Nothing to export yet.');
      }
      var locking = lockingView(scriptPayload);
      var hash = this.app.core.scripting.hash(locking);
      var address = this.app.core.scripting.address(locking);
      if (!hash || !address) {
        throw new Error('Could not derive script address for export.');
      }
      var tx = new Transaction();
      tx.timestamp = Date.now();
      var output = new Slip();
      output.type = SLIP_TYPE_P2SH;
      output.publicKey = this.app.crypto.toBase58(address);
      output.amount = BigInt(0);
      tx.addToSlip(output);
      tx.msg = {
        module: this.name,
        request: 'publish p2sh',
        access_script: JSON.stringify(scriptPayload),
        scripthash: hash,
        p2sh_address: address,
        amount: '0',
        fee: '0',
        draft: true
      };
      return tx;
    }

    /** Export current script state via canonical transaction JSON download. */
  }, {
    key: "exportScriptDraft",
    value: function exportScriptDraft(scriptPayload) {
      var tx = this.buildScriptShareTransaction(scriptPayload);
      return this.exportTransaction(tx, {
        prefix: 'rustscript-draft'
      });
    }

    /**
     * Shareable Pay-to-Script-Hash link — same InvitationLink builder used across Saito apps.
     * Includes confirmed location fields so import can fetch and stamp the spendable UTXO.
     */
  }, {
    key: "buildP2shShareLink",
    value: function buildP2shShareLink() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$p2shHash = _ref2.p2shHash,
        p2shHash = _ref2$p2shHash === void 0 ? '' : _ref2$p2shHash,
        _ref2$p2shAddress = _ref2.p2shAddress,
        p2shAddress = _ref2$p2shAddress === void 0 ? '' : _ref2$p2shAddress,
        _ref2$blockId = _ref2.blockId,
        blockId = _ref2$blockId === void 0 ? null : _ref2$blockId,
        _ref2$transactionId = _ref2.transactionId,
        transactionId = _ref2$transactionId === void 0 ? '' : _ref2$transactionId,
        _ref2$tx = _ref2.tx,
        tx = _ref2$tx === void 0 ? null : _ref2$tx;
      var InvitationLink = require('../../lib/saito/ui/modals/saito-link/saito-link');
      var location = readTransactionLocation(tx);
      var resolvedBlockId = blockId != null && String(blockId) !== '' ? String(blockId) : location.blockId != null ? location.blockId.toString() : '';
      var resolvedTxId = transactionId || location.transactionId || (tx === null || tx === void 0 ? void 0 : tx.signature) || '';
      var data = {
        path: "/".concat(this.returnSlug(), "/"),
        name: this.appname,
        scripthash: p2shHash || '',
        p2sh_address: p2shAddress || ''
      };
      if (resolvedBlockId) {
        data.block_id = resolvedBlockId;
      }
      if (resolvedTxId) {
        data.transaction_id = String(resolvedTxId);
      }
      var linkObj = new InvitationLink(this.app, this, data);
      linkObj.buildLink();
      return linkObj.invite_link || '';
    }

    /**
     * Import a P2SH share link: fetch the confirmed publish tx and load unlock context.
     */
  }, {
    key: "importP2shShareLink",
    value: function () {
      var _importP2shShareLink = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(rawLink) {
        var fields, tx;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              fields = parseP2shShareLink(rawLink);
              _context6.n = 1;
              return fetchTransactionFromP2shLink(this.app, fields);
            case 1:
              tx = _context6.v;
              return _context6.a(2, this.loadTransactionForWitness(tx));
          }
        }, _callee6, this);
      }));
      function importP2shShareLink(_x5) {
        return _importP2shShareLink.apply(this, arguments);
      }
      return importP2shShareLink;
    }()
    /**
     * Unified publish entry — SAITO or NFT to the derived P2SH address.
     * NFT path uses app.wallet.createNFTTransaction (wallet handles shard selection).
     */
  }, {
    key: "publishScript",
    value: function () {
      var _publishScript = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref3) {
        var _ref3$assetType, assetType, locking, p2shAddress, p2shHash, amountSaito, feeSaito, _ref3$nft, nft, _ref3$nftAmount, nftAmount, lockingScript, accessScript, recipient, baseMsg, amountNolan, feeNolan, newtx, amountInt, totalAvailable, _feeNolan, nftTxmsg, txMsg, _newtx;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _ref3$assetType = _ref3.assetType, assetType = _ref3$assetType === void 0 ? 'saito' : _ref3$assetType, locking = _ref3.locking, p2shAddress = _ref3.p2shAddress, p2shHash = _ref3.p2shHash, amountSaito = _ref3.amountSaito, feeSaito = _ref3.feeSaito, _ref3$nft = _ref3.nft, nft = _ref3$nft === void 0 ? null : _ref3$nft, _ref3$nftAmount = _ref3.nftAmount, nftAmount = _ref3$nftAmount === void 0 ? 1 : _ref3$nftAmount;
              lockingScript = lockingView(locking || {});
              accessScript = JSON.stringify(lockingScript);
              recipient = p2shAddress.length === 66 && p2shAddress.startsWith('00') ? this.app.crypto.toBase58(p2shAddress) : p2shAddress;
              baseMsg = {
                module: this.name,
                request: 'publish p2sh',
                access_script: accessScript,
                scripthash: p2shHash,
                p2sh_address: p2shAddress,
                asset_type: assetType,
                fee: String(feeSaito)
              };
              if (!(assetType === 'saito')) {
                _context7.n = 3;
                break;
              }
              amountNolan = this.app.wallet.convertSaitoToNolan(amountSaito);
              feeNolan = this.app.wallet.convertSaitoToNolan(feeSaito);
              _context7.n = 1;
              return this.app.wallet.createUnsignedTransaction(recipient, amountNolan, feeNolan);
            case 1:
              newtx = _context7.v;
              newtx.msg = _objectSpread(_objectSpread({}, baseMsg), {}, {
                amount: String(amountSaito)
              });
              _context7.n = 2;
              return newtx.sign();
            case 2:
              return _context7.a(2, newtx);
            case 3:
              if (!(assetType === 'nft')) {
                _context7.n = 12;
                break;
              }
              if (nft) {
                _context7.n = 4;
                break;
              }
              throw new Error('No NFT selected.');
            case 4:
              _context7.n = 5;
              return nft.fetchTransaction();
            case 5:
              amountInt = parseInt(String(nftAmount), 10);
              if (!(!Number.isInteger(amountInt) || amountInt <= 0)) {
                _context7.n = 6;
                break;
              }
              throw new Error('Enter a valid NFT amount.');
            case 6:
              totalAvailable = nft.getTotalAmount ? nft.getTotalAmount() : 0;
              if (!(amountInt > totalAvailable)) {
                _context7.n = 7;
                break;
              }
              throw new Error("Insufficient NFT units (".concat(totalAvailable, " available)."));
            case 7:
              _feeNolan = this.app.wallet.convertSaitoToNolan(feeSaito);
              nftTxmsg = JSON.parse(JSON.stringify(nft.txmsg || {}));
              txMsg = _objectSpread(_objectSpread({}, baseMsg), {}, {
                nft_id: nft.id,
                nft_amount: String(amountInt),
                nft_txmsg: nftTxmsg,
                amount: '0'
              });
              _context7.n = 8;
              return this.app.wallet.createNFTTransaction(nft, recipient, amountInt, _feeNolan, BigInt(0), txMsg);
            case 8:
              _newtx = _context7.v;
              _context7.n = 9;
              return nft.modifyBeforeSend(_newtx, recipient);
            case 9:
              _newtx = _context7.v;
              if (_newtx) {
                _context7.n = 10;
                break;
              }
              throw new Error('NFT transfer blocked by module.');
            case 10:
              _context7.n = 11;
              return _newtx.sign();
            case 11:
              return _context7.a(2, _newtx);
            case 12:
              throw new Error("Unknown asset type: ".concat(assetType));
            case 13:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function publishScript(_x6) {
        return _publishScript.apply(this, arguments);
      }
      return publishScript;
    }()
    /**
     * CREATE broadcast — construct, sign, start the Transaction Monitor, then propagate.
     */
  }, {
    key: "broadcastPublish",
    value: function () {
      var _broadcastPublish = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var options,
          tx,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              options = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
              _context8.n = 1;
              return this.publishScript(options);
            case 1:
              tx = _context8.v;
              if (tx !== null && tx !== void 0 && tx.signature) {
                _context8.n = 2;
                break;
              }
              throw new Error('Transaction was not signed.');
            case 2:
              if (!this.transaction_monitor) {
                console.error('RustScript: transaction_monitor is not initialized');
              } else {
                this.transaction_monitor.render({
                  tx: tx,
                  title: 'Broadcasting...',
                  lead: 'Your script is being broadcast to the Saito network.',
                  subtitle: 'Waiting for confirmation...',
                  successTitle: 'Transaction Confirmed',
                  successLead: 'Your transaction has been confirmed on the Saito network.',
                  successActionLabel: 'Continue',
                  callback: typeof options.callback === 'function' ? options.callback : null
                });
              }
              _context8.n = 3;
              return this.app.network.propagateTransaction(tx);
            case 3:
              return _context8.a(2, tx);
          }
        }, _callee8, this);
      }));
      function broadcastPublish() {
        return _broadcastPublish.apply(this, arguments);
      }
      return broadcastPublish;
    }()
    /**
     * Load a P2SH publish (or compatible) transaction into the unlock / witness workflow.
     *
     * Category A — txmsg.access_scripts[] present:
     *   Guided mode: locking script restored; user completes witness only.
     * Category B — no txmsg.access_scripts[]:
     *   Expert mode: user must supply locking script and witness.
     */
  }, {
    key: "loadTransactionForWitness",
    value: function () {
      var _loadTransactionForWitness = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(tx) {
        var _options$target;
        var options,
          txmsg,
          p2shAddress,
          lockedSlip,
          assetType,
          lockedNftSlips,
          accessScriptRaw,
          accessScript,
          hash,
          p2shHash,
          hasAccessScript,
          locking,
          _args9 = arguments,
          _t4;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              options = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
              if (tx) {
                _context9.n = 1;
                break;
              }
              throw new Error('Transaction is required');
            case 1:
              if (!((options === null || options === void 0 || (_options$target = options.target) === null || _options$target === void 0 ? void 0 : _options$target.kind) === 'input' && options.target.fromIndex != null)) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2, this.loadP2shInputForWitness(tx, options.target.fromIndex));
            case 2:
              txmsg = typeof tx.returnMessage === 'function' ? tx.returnMessage() : tx.msg || {};
              p2shAddress = txmsg.p2sh_address || txmsg.p2shAddress || this._findP2shOutputAddress(tx) || '';
              lockedSlip = this._findLockedOutputSlip(tx, p2shAddress);
              if (lockedSlip) {
                _context9.n = 3;
                break;
              }
              throw new Error('Could not locate script-locked funds in this transaction.');
            case 3:
              assetType = txmsg.asset_type === 'nft' || txmsg.nft_id ? 'nft' : txmsg.asset_type || 'saito';
              lockedNftSlips = assetType === 'nft' ? this._findLockedNftSlipTriplet(tx, p2shAddress) : null;
              accessScriptRaw = Array.isArray(txmsg.access_scripts) && txmsg.access_scripts.length > 0 ? txmsg.access_scripts[0] : txmsg.access_script || txmsg.accessScript || '';
              accessScript = accessScriptRaw ? JSON.parse(accessScriptRaw) : {};
              hash = this.app.core.scripting.hash(accessScript);
              p2shHash = txmsg.scripthash || hash || '';
              hasAccessScript = typeof accessScriptRaw === 'string' ? accessScriptRaw.trim().length > 0 : accessScriptRaw && _typeof(accessScriptRaw) === 'object';
              this.unlockContext = {
                sourceTxSignature: tx.signature || '',
                p2shAddress: p2shAddress,
                p2shHash: p2shHash,
                lockedSlip: lockedSlip.toJson ? lockedSlip.toJson() : lockedSlip,
                assetType: assetType,
                lockedNftSlips: lockedNftSlips,
                nftId: txmsg.nft_id || '',
                nftAmount: txmsg.nft_amount || '',
                nftTxmsg: txmsg.nft_txmsg && _typeof(txmsg.nft_txmsg) === 'object' ? txmsg.nft_txmsg : null,
                importCategory: hasAccessScript ? 'guided' : 'expert',
                sourceTxmsg: txmsg
              };
              this.workflow = 'unlock';
              this.initializeUnlockTransactions(tx);
              if (!hasAccessScript) {
                _context9.n = 8;
                break;
              }
              _context9.p = 4;
              locking = typeof accessScriptRaw === 'string' ? JSON.parse(accessScriptRaw) : accessScriptRaw;
              _context9.n = 6;
              break;
            case 5:
              _context9.p = 5;
              _t4 = _context9.v;
              throw new Error('access_script is not valid JSON');
            case 6:
              if (!this.main) {
                _context9.n = 7;
                break;
              }
              _context9.n = 7;
              return this.main.enterUnlockGuided(locking);
            case 7:
              _context9.n = 9;
              break;
            case 8:
              if (!this.main) {
                _context9.n = 9;
                break;
              }
              _context9.n = 9;
              return this.main.enterUnlockExpert();
            case 9:
              return _context9.a(2, this.unlockContext);
          }
        }, _callee9, this, [[4, 5]]);
      }));
      function loadTransactionForWitness(_x7) {
        return _loadTransactionForWitness.apply(this, arguments);
      }
      return loadTransactionForWitness;
    }()
    /**
     * Import entry point — detects guided vs expert mode from txmsg.access_scripts[].
     */
  }, {
    key: "importTransactionForUnlock",
    value: function () {
      var _importTransactionForUnlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(tx) {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              return _context0.a(2, this.loadTransactionForWitness(tx));
          }
        }, _callee0, this);
      }));
      function importTransactionForUnlock(_x8) {
        return _importTransactionForUnlock.apply(this, arguments);
      }
      return importTransactionForUnlock;
    }()
  }, {
    key: "_findP2shOutputAddress",
    value: function _findP2shOutputAddress(tx) {
      var outputs = tx.to || [];
      for (var i = 0; i < outputs.length; i++) {
        var slip = outputs[i];
        if (slip !== null && slip !== void 0 && slip.publicKey && String(slip.publicKey).length > 0 && slip.publicKey[0] !== undefined) {
          var pk = slip.publicKey;
          if (typeof pk === 'string' && pk.length >= 66) {
            return pk;
          }
        }
      }
      return '';
    }
  }, {
    key: "_findLockedOutputSlip",
    value: function _findLockedOutputSlip(tx, scriptAddress) {
      var slipKey = scriptAddress.length === 66 && scriptAddress.startsWith('00') ? this.app.crypto.toBase58(scriptAddress) : scriptAddress;
      var outputs = tx.to || [];
      if (slipKey) {
        for (var i = 0; i < outputs.length; i++) {
          var _outputs$i;
          if (((_outputs$i = outputs[i]) === null || _outputs$i === void 0 ? void 0 : _outputs$i.publicKey) === slipKey) {
            return outputs[i];
          }
        }
      }
      for (var _i3 = 0; _i3 < outputs.length; _i3++) {
        var slip = outputs[_i3];
        if (slip !== null && slip !== void 0 && slip.amount && BigInt(slip.amount) > BigInt(0)) {
          return slip;
        }
      }
      return null;
    }

    /**
     * Locate bound-normal-bound NFT output triplet locked at p2shAddress.
     * Mirrors wallet NFT output ordering from create_nft_transaction.
     */
  }, {
    key: "_findLockedNftSlipTriplet",
    value: function _findLockedNftSlipTriplet(tx, scriptAddress) {
      var slipKey = scriptAddress.length === 66 && scriptAddress.startsWith('00') ? this.app.crypto.toBase58(scriptAddress) : scriptAddress;
      var outputs = tx.to || [];
      for (var i = 1; i < outputs.length - 1; i++) {
        var slip1 = outputs[i - 1];
        var slip2 = outputs[i];
        var slip3 = outputs[i + 1];
        if (!slip2 || slip2.publicKey !== slipKey) {
          continue;
        }
        if (!isBoundSlipType(slip1 === null || slip1 === void 0 ? void 0 : slip1.type)) {
          continue;
        }
        if (!isNormalOrAtrSlipType(slip2 === null || slip2 === void 0 ? void 0 : slip2.type)) {
          continue;
        }
        if (!isBoundSlipType(slip3 === null || slip3 === void 0 ? void 0 : slip3.type)) {
          continue;
        }
        return [slip1, slip2, slip3].map(slipToStoredJson);
      }
      return null;
    }

    /**
     * Construct and broadcast a P2SH unlock transaction.
     * Prefers the silently funded unlock_transaction_final once the fee is set.
     * Starts the Transaction Monitor immediately before network propagation.
     */
  }, {
    key: "broadcastSolution",
    value: function () {
      var _broadcastSolution = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var _ref4,
          _ref4$destinationPubl,
          destinationPublicKey,
          _ref4$feeSaito,
          feeSaito,
          _ref4$callback,
          callback,
          ctx,
          _args1 = arguments;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _ref4 = _args1.length > 0 && _args1[0] !== undefined ? _args1[0] : {}, _ref4$destinationPubl = _ref4.destinationPublicKey, destinationPublicKey = _ref4$destinationPubl === void 0 ? '' : _ref4$destinationPubl, _ref4$feeSaito = _ref4.feeSaito, feeSaito = _ref4$feeSaito === void 0 ? '0' : _ref4$feeSaito, _ref4$callback = _ref4.callback, callback = _ref4$callback === void 0 ? null : _ref4$callback;
              ctx = this.unlockContext;
              if (!(!(ctx !== null && ctx !== void 0 && ctx.lockedSlip) && !(Array.isArray(ctx === null || ctx === void 0 ? void 0 : ctx.lockedNftSlips) && ctx.lockedNftSlips.length))) {
                _context1.n = 1;
                break;
              }
              throw new Error('No unlock context — load a script-locked transaction first');
            case 1:
              if (!(this.unlock_transaction_base && this.unlock_fee)) {
                _context1.n = 2;
                break;
              }
              return _context1.a(2, this.broadcastUnlockBaseTransaction({
                destinationPublicKey: destinationPublicKey,
                callback: callback
              }));
            case 2:
              if (destinationPublicKey) {
                _context1.n = 3;
                break;
              }
              throw new Error('Destination public key is required');
            case 3:
              if (!(ctx.assetType === 'nft' && Array.isArray(ctx.lockedNftSlips) && ctx.lockedNftSlips.length === 3)) {
                _context1.n = 4;
                break;
              }
              return _context1.a(2, this.broadcastNftSolution({
                destinationPublicKey: destinationPublicKey,
                feeSaito: feeSaito,
                callback: callback
              }));
            case 4:
              return _context1.a(2, this.broadcastSaitoSolution({
                destinationPublicKey: destinationPublicKey,
                feeSaito: feeSaito,
                callback: callback
              }));
          }
        }, _callee1, this);
      }));
      function broadcastSolution() {
        return _broadcastSolution.apply(this, arguments);
      }
      return broadcastSolution;
    }()
    /**
     * Sign and propagate the funded unlock transaction (fee inputs + change included).
     */
  }, {
    key: "broadcastUnlockBaseTransaction",
    value: function () {
      var _broadcastUnlockBaseTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var _userOutputs$, _userOutputs$2;
        var _ref5,
          _ref5$destinationPubl,
          destinationPublicKey,
          _ref5$callback,
          callback,
          ctx,
          base,
          _require9,
          ensureDefaultUnlockFee,
          _require0,
          ensureUnlockFeeFunded,
          assignOutputSlipIndices,
          funded,
          fullScript,
          accessScript,
          tx,
          userOutputs,
          destination,
          _ctx$lockedNftSlips,
          _ctx$lockedNftSlips2,
          _args10 = arguments;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _ref5 = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {}, _ref5$destinationPubl = _ref5.destinationPublicKey, destinationPublicKey = _ref5$destinationPubl === void 0 ? '' : _ref5$destinationPubl, _ref5$callback = _ref5.callback, callback = _ref5$callback === void 0 ? null : _ref5$callback;
              ctx = this.unlockContext;
              base = this.unlock_transaction_base;
              if (base) {
                _context10.n = 1;
                break;
              }
              throw new Error('Unlock transaction is not ready.');
            case 1:
              if (!this.unlock_fee) {
                _require9 = require('./lib/ui/unlock_tx_fee'), ensureDefaultUnlockFee = _require9.ensureDefaultUnlockFee;
                ensureDefaultUnlockFee(this);
              }
              _require0 = require('./lib/ui/unlock_tx_fee'), ensureUnlockFeeFunded = _require0.ensureUnlockFeeFunded, assignOutputSlipIndices = _require0.assignOutputSlipIndices;
              _context10.n = 2;
              return ensureUnlockFeeFunded(this.app, this);
            case 2:
              funded = _context10.v;
              assignOutputSlipIndices(funded);
              fullScript = this.getScript();
              accessScript = JSON.stringify(fullScript);
              tx = this.cloneTransactionSkeleton(funded);
              if ((ctx === null || ctx === void 0 ? void 0 : ctx.assetType) === 'nft') {
                tx.type = TransactionType.Bound;
              }
              userOutputs = Array.isArray(base.to) ? base.to : [];
              destination = destinationPublicKey || String(((_userOutputs$ = userOutputs[0]) === null || _userOutputs$ === void 0 ? void 0 : _userOutputs$.publicKey) || ((_userOutputs$2 = userOutputs[0]) === null || _userOutputs$2 === void 0 ? void 0 : _userOutputs$2.public_key) || '') || '';
              tx.msg = {
                module: this.name,
                request: 'spend p2sh',
                access_scripts: [accessScript],
                scripthash: ctx.p2shHash,
                p2sh_address: ctx.p2shAddress,
                destination: destination,
                fee: String(this.unlock_fee.feeSaito || ''),
                source_tx: ctx.sourceTxSignature || ''
              };
              if ((ctx === null || ctx === void 0 ? void 0 : ctx.assetType) === 'nft') {
                tx.msg.asset_type = 'nft';
                tx.msg.nft_id = ctx.nftId || ((_ctx$lockedNftSlips = ctx.lockedNftSlips) === null || _ctx$lockedNftSlips === void 0 || (_ctx$lockedNftSlips = _ctx$lockedNftSlips[2]) === null || _ctx$lockedNftSlips === void 0 ? void 0 : _ctx$lockedNftSlips.publicKey) || '';
                tx.msg.nft_amount = ctx.nftAmount || String(((_ctx$lockedNftSlips2 = ctx.lockedNftSlips) === null || _ctx$lockedNftSlips2 === void 0 || (_ctx$lockedNftSlips2 = _ctx$lockedNftSlips2[0]) === null || _ctx$lockedNftSlips2 === void 0 ? void 0 : _ctx$lockedNftSlips2.amount) || '0');
                if (ctx.nftTxmsg && _typeof(ctx.nftTxmsg) === 'object') {
                  Object.assign(tx.msg, ctx.nftTxmsg);
                }
              }
              _context10.n = 3;
              return tx.sign();
            case 3:
              if (tx.signature) {
                _context10.n = 4;
                break;
              }
              throw new Error('Unlock transaction was not signed');
            case 4:
              if (!this.transaction_monitor) {
                console.error('RustScript: transaction_monitor is not initialized');
              } else {
                this.transaction_monitor.render({
                  tx: tx,
                  title: 'Broadcasting...',
                  lead: 'Your unlock transaction is being broadcast to the Saito network.',
                  subtitle: 'Waiting for confirmation...',
                  successTitle: 'Script Unlocked',
                  successLead: 'Your unlock transaction has been confirmed and the locked funds have been released.',
                  successActionLabel: 'Continue',
                  callback: typeof callback === 'function' ? callback : null
                });
              }
              _context10.n = 5;
              return this.app.network.propagateTransaction(tx);
            case 5:
              return _context10.a(2, tx);
          }
        }, _callee10, this);
      }));
      function broadcastUnlockBaseTransaction() {
        return _broadcastUnlockBaseTransaction.apply(this, arguments);
      }
      return broadcastUnlockBaseTransaction;
    }()
    /**
     * SAITO unlock — legacy rebuild path (fee deducted from locked UTXO).
     * Kept for callers that have not configured unlock_fee on unlock_transaction_base.
     */
  }, {
    key: "broadcastSaitoSolution",
    value: function () {
      var _broadcastSaitoSolution = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var _ref6,
          _ref6$destinationPubl,
          destinationPublicKey,
          _ref6$feeSaito,
          feeSaito,
          _ref6$callback,
          callback,
          ctx,
          fullScript,
          accessScript,
          feeNolan,
          lockedAmount,
          outputAmount,
          tx,
          lockedInput,
          output,
          _args11 = arguments;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _ref6 = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {}, _ref6$destinationPubl = _ref6.destinationPublicKey, destinationPublicKey = _ref6$destinationPubl === void 0 ? '' : _ref6$destinationPubl, _ref6$feeSaito = _ref6.feeSaito, feeSaito = _ref6$feeSaito === void 0 ? '0' : _ref6$feeSaito, _ref6$callback = _ref6.callback, callback = _ref6$callback === void 0 ? null : _ref6$callback;
              ctx = this.unlockContext;
              if (ctx !== null && ctx !== void 0 && ctx.lockedSlip) {
                _context11.n = 1;
                break;
              }
              throw new Error('No unlock context — load a script-locked transaction first');
            case 1:
              if (destinationPublicKey) {
                _context11.n = 2;
                break;
              }
              throw new Error('Destination public key is required');
            case 2:
              fullScript = this.getScript();
              accessScript = JSON.stringify(fullScript);
              feeNolan = this.app.wallet.convertSaitoToNolan(feeSaito || '0');
              lockedAmount = BigInt(ctx.lockedSlip.amount || 0);
              outputAmount = lockedAmount - feeNolan; // Fee larger than the locked UTXO cannot be funded from this input alone.
              if (!(outputAmount < BigInt(0))) {
                _context11.n = 3;
                break;
              }
              throw new Error('Fee exceeds locked amount');
            case 3:
              tx = new Transaction();
              tx.timestamp = Date.now();
              lockedInput = new Slip(undefined, ctx.lockedSlip);
              tx.addFromSlip(lockedInput);
              output = new Slip();
              output.publicKey = destinationPublicKey;
              output.amount = outputAmount;
              tx.addToSlip(output);
              tx.msg = {
                module: this.name,
                request: 'spend p2sh',
                access_scripts: [accessScript],
                scripthash: ctx.p2shHash,
                p2sh_address: ctx.p2shAddress,
                destination: destinationPublicKey,
                fee: String(feeSaito),
                source_tx: ctx.sourceTxSignature || ''
              };
              _context11.n = 4;
              return tx.sign();
            case 4:
              if (tx.signature) {
                _context11.n = 5;
                break;
              }
              throw new Error('Unlock transaction was not signed');
            case 5:
              if (!this.transaction_monitor) {
                console.error('RustScript: transaction_monitor is not initialized');
              } else {
                this.transaction_monitor.render({
                  tx: tx,
                  title: 'Broadcasting...',
                  lead: 'Your unlock transaction is being broadcast to the Saito network.',
                  subtitle: 'Waiting for confirmation...',
                  successTitle: 'Script Unlocked',
                  successLead: 'Your unlock transaction has been confirmed and the locked funds have been released.',
                  successActionLabel: 'Continue',
                  callback: typeof callback === 'function' ? callback : null
                });
              }
              _context11.n = 6;
              return this.app.network.propagateTransaction(tx);
            case 6:
              return _context11.a(2, tx);
          }
        }, _callee11, this);
      }));
      function broadcastSaitoSolution() {
        return _broadcastSaitoSolution.apply(this, arguments);
      }
      return broadcastSaitoSolution;
    }()
    /**
     * NFT unlock — preserve bound-normal-bound slip triplet (same semantics as create_send_bound_transaction).
     *
     * Slips copied:
     *   slip1 — Bound, NFT amount (creator public key)
     *   slip2 — Normal, SAITO deposit (recipient updated to destination)
     *   slip3 — Bound, NFT uuid (amount 0)
     *
     * Transaction type: Bound (required for wallet NFT recognition).
     */
  }, {
    key: "broadcastNftSolution",
    value: function () {
      var _broadcastNftSolution = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var _slips$, _slips$2;
        var _ref7,
          _ref7$destinationPubl,
          destinationPublicKey,
          _ref7$feeSaito,
          feeSaito,
          _ref7$callback,
          callback,
          ctx,
          slips,
          fullScript,
          accessScript,
          feeNolan,
          depositAmount,
          outputDeposit,
          tx,
          _iterator2,
          _step2,
          stored,
          out1,
          out2,
          out3,
          _args12 = arguments;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _ref7 = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {}, _ref7$destinationPubl = _ref7.destinationPublicKey, destinationPublicKey = _ref7$destinationPubl === void 0 ? '' : _ref7$destinationPubl, _ref7$feeSaito = _ref7.feeSaito, feeSaito = _ref7$feeSaito === void 0 ? '0' : _ref7$feeSaito, _ref7$callback = _ref7.callback, callback = _ref7$callback === void 0 ? null : _ref7$callback;
              ctx = this.unlockContext;
              slips = ctx.lockedNftSlips;
              fullScript = this.getScript();
              accessScript = JSON.stringify(fullScript);
              feeNolan = this.app.wallet.convertSaitoToNolan(feeSaito || '0');
              depositAmount = BigInt(slips[1].amount || 0); // NFT unlocks may be fee-costly relative to the deposit — never refuse on that basis.
              // If the fee would consume the deposit, keep the deposit intact on the output.
              outputDeposit = depositAmount - feeNolan;
              if (outputDeposit <= BigInt(0)) {
                outputDeposit = depositAmount;
              }
              tx = new Transaction();
              tx.timestamp = Date.now();
              tx.type = TransactionType.Bound;
              _iterator2 = _createForOfIteratorHelper(slips);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  stored = _step2.value;
                  tx.addFromSlip(new Slip(undefined, stored));
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              out1 = new Slip(undefined, _objectSpread({}, slips[0]));
              out2 = new Slip(undefined, _objectSpread(_objectSpread({}, slips[1]), {}, {
                publicKey: destinationPublicKey,
                amount: outputDeposit
              }));
              out3 = new Slip(undefined, _objectSpread({}, slips[2]));
              tx.addToSlip(out1);
              tx.addToSlip(out2);
              tx.addToSlip(out3);
              tx.msg = {
                module: this.name,
                request: 'spend p2sh',
                asset_type: 'nft',
                access_scripts: [accessScript],
                scripthash: ctx.p2shHash,
                p2sh_address: ctx.p2shAddress,
                destination: destinationPublicKey,
                fee: String(feeSaito),
                source_tx: ctx.sourceTxSignature || '',
                nft_id: ctx.nftId || ((_slips$ = slips[2]) === null || _slips$ === void 0 ? void 0 : _slips$.publicKey) || '',
                nft_amount: ctx.nftAmount || String(((_slips$2 = slips[0]) === null || _slips$2 === void 0 ? void 0 : _slips$2.amount) || '0')
              };
              if (ctx.nftTxmsg && _typeof(ctx.nftTxmsg) === 'object') {
                Object.assign(tx.msg, ctx.nftTxmsg);
              }
              _context12.n = 1;
              return tx.sign();
            case 1:
              if (tx.signature) {
                _context12.n = 2;
                break;
              }
              throw new Error('Unlock transaction was not signed');
            case 2:
              if (!this.transaction_monitor) {
                console.error('RustScript: transaction_monitor is not initialized');
              } else {
                this.transaction_monitor.render({
                  tx: tx,
                  title: 'Broadcasting...',
                  lead: 'Your unlock transaction is being broadcast to the Saito network.',
                  subtitle: 'Waiting for confirmation...',
                  successTitle: 'Script Unlocked',
                  successLead: 'Your unlock transaction has been confirmed and the locked funds have been released.',
                  successActionLabel: 'Continue',
                  callback: typeof callback === 'function' ? callback : null
                });
              }
              _context12.n = 3;
              return this.app.network.propagateTransaction(tx);
            case 3:
              return _context12.a(2, tx);
          }
        }, _callee12, this);
      }));
      function broadcastNftSolution() {
        return _broadcastNftSolution.apply(this, arguments);
      }
      return broadcastNftSolution;
    }()
  }]);
}(ModTemplate);
module.exports = Rustscript;